"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "chimeMetricsOnstageAttendeeUpdaterMiddleware", {
  enumerable: true,
  get: function get() {
    return _chimeMetricsOnstageAttendeeUpdaterMiddleware.chimeMetricsOnstageAttendeeUpdaterMiddleware;
  }
});
var _chimeMetricsOnstageAttendeeUpdaterMiddleware = require("./chimeMetricsOnstageAttendeeUpdaterMiddleware");